import { render, staticRenderFns } from "./DocumentContextMenu.vue?vue&type=template&id=c507eafc&scoped=true"
import script from "./DocumentContextMenu.vue?vue&type=script&lang=js"
export * from "./DocumentContextMenu.vue?vue&type=script&lang=js"
import style0 from "./DocumentContextMenu.vue?vue&type=style&index=0&id=c507eafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c507eafc",
  null
  
)

export default component.exports